



































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { LazyLoader } from "../../../../../base/components/system";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { DragKinds } from "../../../../../base/components/dragging";
import { IBehaviorDocumentEditorObjectLazyDrawerConfiguration } from "../../../../../base/domain/configuration";
import { Size, ISize, IPoint } from "../../../../../base/domain/drawing";
import { DomainRegistry } from "../../../../domain";
import { IConfiguration } from "../../../../domain/configuration";
import { IFormatObjectEditable, IFormatObjectTemporaryImage, FormatPageStructureEditor } from "../../../../domain/editableFormat";
import { instanceOfIRectangleCoordinateEditable, instanceOfIImageContentPropertyEditable } from "../../../../domain/editableFormat/properties";
import { FormatPageStructureEditableMixin, CommonComponentsAccessibleMixin, UploadImageFileMixin, QuestionnaireGuidAssignableMixin } from "../mixins";
import { QuestionnaireRelationIndiator } from "./indicators";
import { FormatPageInputTracker, FormatPageObjectDragTracker, FormatPageLocator, IFormatPageLocatable } from "./trackers";
import { default as FormatPageObjectDrawer } from "./FormatPageObjectDrawer.vue";
import { default as FormatPageObjectMenu } from "./FormatPageObjectMenu.vue";

@Component({
  components: {
    FormatPageInputTracker,
    FormatPageObjectDrawer,
    FormatPageObjectMenu,
    FormatPageObjectDragTracker,
    FormatPageLocator,
    LazyLoader,
    QuestionnaireRelationIndiator,
  }
})
export default class FormatPageEditor extends Mixins(ModelEditableMixin, FormatPageStructureEditableMixin, CommonComponentsAccessibleMixin, UploadImageFileMixin, QuestionnaireGuidAssignableMixin) {
  writePropertyWhenValid: (writer: (source: FormatPageStructureEditor) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: FormatPageStructureEditor) => T, defaultValue: T) => T;

  @Prop({ default: 1 })
  scale: number;

  @Prop({ default: () => new Size(10, 10) })
  gridSize: Size;

  @Prop()
  isActive: boolean;

  $refs!: {
    page: HTMLDivElement,
    menu: FormatPageObjectMenu,
    objectDragTracker: FormatPageObjectDragTracker,
    locator: FormatPageLocator,
    lazyLoader: LazyLoader,
  };
  $configuration!: IConfiguration;

  data() {
    return {
      pageElement: null as HTMLDivElement,
      drawableObjects: [] as IFormatObjectEditable[],
    };
  }
  pageElement: HTMLDivElement;
  drawableObjects: IFormatObjectEditable[];

  private lastDropPoint: IPoint<number> = null;

  mounted() {
    this.pageElement = this.$refs.page;
  }

  updated() {
    this.$refs.lazyLoader.loadNext();
  }

  get lazyDrawerConfiguration(): IBehaviorDocumentEditorObjectLazyDrawerConfiguration {
    return this.$configuration.formatEditor.behavior.format.editor.objectLazyDrawer;
  }

  @Watch("editingSource")
  onEditingSourceUpdated(newValue: FormatPageStructureEditor, oldValue: FormatPageStructureEditor) {
    if (!newValue.isReferedSameSource(oldValue)) {
      this.$refs.lazyLoader.restart();
    }
  }

  getLocator(): IFormatPageLocatable {
    return this.$refs.locator;
  }

  get pageSizeStyleProperties() {
    const image = this.image;
    if (!image) {
      return null;
    }
    const isHorizontal = this.isHorizontal;
    return {
      width: (isHorizontal ? image.size.height : image.size.width) + "px",
      height: (isHorizontal ? image.size.width : image.size.height) + "px"
    };
  }

  get layerRectangleStyleProperties() {
    const layer = this.layer;
    if (!layer || !layer.imageGuid) {
      return null;
    }
    return {
      left: layer.location.x + "px",
      top: layer.location.y + "px",
      width: layer.size.width + "px",
      height: layer.size.height + "px"
    };
  }

  get layerSource(): string {
    const layer = this.layer;
    if (!layer || !layer.imageGuid) {
      return null;
    }
    const repository = DomainRegistry.instance.editableFormat.getFormatRepository();
    const imageSource = layer.formatId
      ? repository.getLayerImageSource(layer.formatId, layer.imageGuid)
      : repository.getTemporaryImageSource(layer.imageGuid);
    return imageSource.source;
  }

  get temporaryImages(): IFormatObjectTemporaryImage[] {
    return this.storePresenter.getTemporaryImages();
  }

  onDropImages(event: DragEvent) {
    const current = event.currentTarget as Element;
    if (!current) {
      return;
    }
    const clientRect = current.getBoundingClientRect();
    this.lastDropPoint = {
      x: (event.pageX - clientRect.left - window.pageXOffset) / this.scale,
      y: (event.pageY - clientRect.top - window.pageYOffset) / this.scale
    };
    this.uploadImages(event.dataTransfer.files);
  }

  async uploadedImage(imageGuid: string, size: ISize<number>, fileName: string): Promise<void> {
    this.deselectAllObjects();
    await this.$nextTick();
    this.addTemporaryImage(imageGuid, size);
    this.addNewImageObject(imageGuid, size);
  }

  private addTemporaryImage(imageGuid: string, size: ISize<number>) {
    this.getCommonComponents().getStoreEditor().setTemporaryImages(this.temporaryImages.concat([{
      imageGuid: imageGuid,
      size: size,
    }]));
  }

  private addNewImageObject(imageGuid: string, size: ISize<number>) {
    const object = this.readPropertyOrDefault(s => s.createNewObject("NewImage"), null);
    if (!instanceOfIRectangleCoordinateEditable(object) || !instanceOfIImageContentPropertyEditable(object)) {
      return;
    }
    object.temporaryImageContent().setValue({ guid: imageGuid, isEnable: true });
    object.location().setValue(this.lastDropPoint);
    object.size().setValue(size);
    this.assignNewGuidForQuestionnaire(object); // Questionnaire拡張使用時GUIDをアサインする.
    this.writePropertyWhenValid(s => s.addObject(object));
  }

  onDragHandleSelected(source: IFormatObjectEditable, event: PointerEvent, kind: DragKinds): void {
    this.$refs.objectDragTracker.drag(source, event, kind);
  }

  onObjectMouseDownCaptured(sender: IFormatObjectEditable, event: PointerEvent): void {
    this.$refs.menu.handleMouseDownCaptured(sender, event);
  }

  onPageMouseRightDownHandled(event: PointerEvent): void {
    this.$refs.menu.handlePageMouseRightDowned(event);
  }
}
